module.exports = __webpack_public_path__ + "media/images/img_jpx-935c563c67917c8d3e7ebf0185a25f49.png";